import { render, staticRenderFns } from "./CotPropostaAccessoModuloEditComponent.vue?vue&type=template&id=261d7deb"
import script from "./CotPropostaAccessoModuloEditComponent.vue?vue&type=script&lang=js"
export * from "./CotPropostaAccessoModuloEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports